import { render } from "./SquarePanel.vue?vue&type=template&id=381e0775&scoped=true&ts=true"
import script from "./SquarePanel.vue?vue&type=script&lang=ts"
export * from "./SquarePanel.vue?vue&type=script&lang=ts"

import "./SquarePanel.vue?vue&type=style&index=0&id=381e0775&scoped=true&lang=css"

import exportComponent from "C:\\Users\\breno\\Documents\\Workspace\\Coll\\palavra-quadrada\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-381e0775"]])

export default __exports__